import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Play } from 'lucide-react';

const stats = [
  { value: '150K+', label: 'Sq Ft Facility' },
  { value: '50,000', label: 'MT Capacity/Year' },
  { value: '500+', label: 'Enterprise Clients' },
  { value: '98%', label: 'Recovery Rate' },
];

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden bg-[#0a1628]">
      {/* Video Background */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute w-full h-full object-cover opacity-40"
          poster="https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=1920&q=80"
        >
          <source 
            src="https://videos.pexels.com/video-files/3209828/3209828-uhd_2560_1440_25fps.mp4" 
            type="video/mp4" 
          />
        </video>
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a1628] via-[#0a1628]/80 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 min-h-[90vh] flex flex-col justify-center">
        <div className="w-full pt-28 pb-8 md:py-32">
          <div className="max-w-2xl">
            {/* Tagline */}
            <p className="text-[#4fd1c5] text-sm font-semibold tracking-[0.2em] uppercase mb-6">
              UAE's Leading E-Waste Recycler
            </p>

            {/* Main Headline */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light text-white leading-tight mb-6">
              Closing the loop on
              <span className="block font-semibold">electronic waste</span>
            </h1>

            {/* Subtext */}
            <p className="text-lg text-gray-400 max-w-lg mb-10 leading-relaxed">
              We transform end-of-life electronics into valuable resources through certified recycling, 
              secure data destruction, and sustainable practices.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4">
              <Link 
                to="/contact" 
                className="inline-flex items-center gap-2 bg-[#4fd1c5] hover:bg-[#38b2ac] text-[#0a1628] px-7 py-3.5 font-semibold transition-colors"
                data-testid="hero-request-pickup-btn"
              >
                Request a Pickup
                <ArrowRight className="w-5 h-5" />
              </Link>
              <Link 
                to="/process" 
                className="inline-flex items-center gap-2 border border-white/30 hover:border-white/60 text-white px-7 py-3.5 font-semibold transition-colors"
                data-testid="hero-see-how-btn"
              >
                <Play className="w-4 h-4" />
                How It Works
              </Link>
            </div>
          </div>
        </div>

        {/* Mobile Stats - inline flow */}
        <div className="md:hidden pb-6" data-testid="hero-stats-mobile">
          <div className="grid grid-cols-2 gap-4 bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-5">
            {stats.map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-xl font-semibold text-white">{stat.value}</div>
                <div className="text-xs text-gray-400 mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Desktop Stats Bar - absolute bottom */}
      <div className="hidden md:block absolute bottom-0 left-0 right-0 z-10 bg-white/5 backdrop-blur-sm border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="grid grid-cols-4 gap-8">
            {stats.map((stat, i) => (
              <div key={i} className="text-left" data-testid={`hero-stat-${i}`}>
                <div className="text-2xl lg:text-3xl font-semibold text-white">{stat.value}</div>
                <div className="text-sm text-gray-400">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
